const pointsConstants = {};

pointsConstants.LIST_POINTS = 'LIST_POINTS';
pointsConstants.RETRIEVE_POINTS = 'RETRIEVE_POINTS';
pointsConstants.CREATE_POINTS = 'CREATE_POINTS';
pointsConstants.UPDATE_POINTS = 'UPDATE_POINTS';
pointsConstants.DESTROY_POINTS = 'DESTROY_POINTS';

export default pointsConstants;



/** WEBPACK FOOTER **
 ** ./src/constants/points.js
 **/